module.exports = __webpack_public_path__ + "static/media/icon_147.99574fc8.svg";